exports.objectiveDisplayNameMap = {
    ecpa: 'eCPA',
    ctr: 'CTR',
    ekpi: 'eKPI'
};
const programmaticObjectiveNakedTokenInner = 'objective';
exports.programmaticObjectiveNakedToken = programmaticObjectiveNakedTokenInner;



// WEBPACK FOOTER //
// ./src/constants/programmaticObjectives.js